(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp-avis-mini"] && !Shopify.designMode) return;
  try {
    
(function () {
  function place() {
    var node = document.querySelector('.dp-avismini[data-avismini-relocate]');
    if (!node) return;
    // Ancre STABLE = badges de paiement (ne bougent jamais). Le combo s'étant déjà
    // placé après cette ancre, insérer ici met les avis juste avant le combo.
    var anchor = document.querySelector('.dp-pay-row') || document.querySelector('form[action*="/cart/add"]:not(.installment)');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(node, anchor.nextSibling);
    node.style.display = '';
    node.removeAttribute('data-avismini-relocate');
  }
  // setTimeout(…, 0) garantit qu'on passe APRÈS la relocalisation du combo (DOMContentLoaded)
  function schedule() { setTimeout(place, 0); }
  if (document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-frise"] && !Shopify.designMode) return;
  try {
    
(function () {
  function placer() {
    var f = document.querySelector('.dp-frise[data-frise-relocate]');
    if (!f) return;
    /* Dawn : la frise se place juste sous les boutons d'achat */
    var form = document.querySelector('product-info product-form') || document.querySelector('product-info .product-form');
    if (!form || !form.parentNode) return;
    var cible = { appendChild: function (n) { form.parentNode.insertBefore(n, form.nextSibling); } };
    cible.appendChild(f);
    f.style.display = '';
    f.removeAttribute('data-frise-relocate');
  }
  if (document.readyState !== 'loading') placer();
  else document.addEventListener('DOMContentLoaded', placer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souvent-achetes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function L(k, d) { var o = (window.DoucePatte && window.DoucePatte.i18n) || {}; return o[k] || d; }
  function euro(cents) { if (window.DoucePatte && window.DoucePatte.money) return window.DoucePatte.money(cents); return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  // 1) Repositionne le bloc juste sous le bouton d'achat (buy box)
  function relocate() {
    var node = document.querySelector('.dp-fbt-inline[data-fbt-relocate]');
    if (!node) return;
    var form = document.querySelector('form[action*="/cart/add"]:not(.installment)');
    var anchor = document.querySelector('.dp-pay-row') || form;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(node, anchor.nextSibling);
    }
    node.style.display = '';
    node.removeAttribute('data-fbt-relocate');
  }
  if (document.readyState !== 'loading') relocate(); else document.addEventListener('DOMContentLoaded', relocate);

  // 2) Logique du combo
  document.querySelectorAll('[data-fbt]').forEach(function (root) {
    if (root.dataset.fbtInit) return; root.dataset.fbtInit = '1';
    var checks = root.querySelectorAll('.dp-fbt__check');
    var totalEl = root.querySelector('[data-fbt-total]');
    var addBtn = root.querySelector('[data-fbt-add]');
    var syncing = false;
    var form = document.querySelector('form[action*="/cart/add"]:not(.installment)');
    var mainCheck = root.querySelector('.dp-fbt__check[data-main]');
    var mainItem = mainCheck ? mainCheck.closest('.dp-fbt__item') : null;
    var mainSel = mainItem ? mainItem.querySelector('[data-fbt-main-variant]') : null;

    function applyItemPrice(item, cents, variantId) {
      if (!item) return;
      var check = item.querySelector('.dp-fbt__check');
      var priceEl = item.querySelector('[data-fbt-price]');
      if (check) {
        check.dataset.price = String(cents);
        if (variantId) check.dataset.variant = String(variantId);
      }
      if (priceEl) priceEl.textContent = euro(cents);
    }

    function priceOf(c) {
      var item = c.closest('.dp-fbt__item');
      var sel = item ? item.querySelector('.dp-fbt__variant') : null;
      if (sel && sel.options[sel.selectedIndex]) {
        return parseInt(sel.options[sel.selectedIndex].dataset.price || c.dataset.price || '0', 10);
      }
      return parseInt(c.dataset.price || '0', 10);
    }

    function variantOf(c) {
      if (c.dataset.main === '1') {
        if (mainSel && mainSel.value) return mainSel.value;
        var live = form ? form.querySelector('[name="id"]') : null;
        if (live && live.value) return live.value;
      }
      var item = c.closest('.dp-fbt__item');
      var sel = item ? item.querySelector('.dp-fbt__variant') : null;
      if (sel && sel.value) return sel.value;
      return c.dataset.variant;
    }

    function recalc() {
      var t = 0;
      var n = 0;
      checks.forEach(function (c) { if (c.checked) { t += priceOf(c); n += 1; } });
      if (totalEl) totalEl.textContent = euro(t);
      if (addBtn) {
        var label = addBtn.querySelector('span');
        if (label && !addBtn.disabled) {
          label.textContent = n > 1 ? L('fbt_add_sel', 'Ajouter la sélection') : L('fbt_add', 'Ajouter au panier');
        }
      }
    }

    function syncPdpToFbt() {
      if (syncing || !mainCheck) return;
      var live = form ? form.querySelector('[name="id"]') : null;
      if (!live || !live.value) return;
      var id = String(live.value);
      var cents = null;
      if (mainSel) {
        var opt = null;
        for (var i = 0; i < mainSel.options.length; i++) {
          if (String(mainSel.options[i].value) === id) { opt = mainSel.options[i]; break; }
        }
        if (!opt || opt.disabled) return;
        if (mainSel.value !== id) mainSel.value = id;
        cents = parseInt(opt.dataset.price || '0', 10);
      } else {
        cents = parseInt(mainCheck.dataset.price || '0', 10);
      }
      applyItemPrice(mainItem, cents, id);
      recalc();
    }

    function syncFbtToPdp(variantId) {
      if (!form || !variantId) return;
      syncing = true;
      var idSelect = form.querySelector('select[name="id"]');
      var title = '';
      if (idSelect) {
        idSelect.value = String(variantId);
        var opt = idSelect.options[idSelect.selectedIndex];
        title = opt ? opt.textContent.trim() : '';
      }
      if (title) {
        var parts = title.replace(/\s*—\s*(épuisé|sold out)\s*$/i, '').split(/\s*\/\s*/);
        form.querySelectorAll('input[type="radio"][name^="options"]').forEach(function (inp) {
          if (parts.indexOf(inp.value) !== -1) inp.checked = true;
        });
      }
      var checked = form.querySelector('input[type="radio"][name^="options"]:checked');
      if (checked) {
        checked.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (idSelect) {
        idSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setTimeout(function () { syncing = false; }, 0);
    }

    checks.forEach(function (c) { c.addEventListener('change', recalc); });

    root.querySelectorAll('.dp-fbt__variant').forEach(function (sel) {
      sel.addEventListener('mousedown', function (e) { e.stopPropagation(); });
      sel.addEventListener('click', function (e) { e.stopPropagation(); });
      sel.addEventListener('change', function () {
        var item = sel.closest('.dp-fbt__item');
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var cents = parseInt(opt.dataset.price || '0', 10);
        applyItemPrice(item, cents, opt.value);
        if (sel.hasAttribute('data-fbt-main-variant')) syncFbtToPdp(opt.value);
        recalc();
      });
    });

    if (form) {
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.name === 'id' || (t.name && String(t.name).indexOf('options') === 0)) {
          setTimeout(syncPdpToFbt, 0);
        }
      });
    }

    // Align pack on current PDP variant at init
    syncPdpToFbt();
    recalc();

    if (addBtn) addBtn.addEventListener('click', function () {
      var items = [];
      checks.forEach(function (c) {
        if (!c.checked) return;
        var id = variantOf(c);
        if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      if (!items.length) return;
      var label = addBtn.querySelector('span');
      var old = label ? label.textContent : '';
      if (label) label.textContent = L('fbt_adding', 'Ajout…');
      addBtn.disabled = true;
      var done = function () {
        if (label) label.textContent = L('fbt_added', '✓ Ajouté');
        setTimeout(function () { if (label) label.textContent = old; addBtn.disabled = false; recalc(); }, 1800);
      };
      var fail = function (err) {
        if (label) label.textContent = (err && err.description) ? err.description : L('fbt_error', 'Ajout impossible — réessayez');
        setTimeout(function () { if (label) label.textContent = old; addBtn.disabled = false; }, 2500);
      };
      /* Panier tiroir disponible : ajout + ouverture du tiroir (29 sept 2026) */
      if (window.DoucePatte && window.DoucePatte.cart) {
        window.DoucePatte.cart.add(items).then(done).catch(fail);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
        .then(function () {
          if (window.DoucePatte && window.DoucePatte.refreshCart) window.DoucePatte.refreshCart();
          if (label) label.textContent = L('fbt_added', '✓ Ajouté');
          setTimeout(function () { window.location.href = '/cart'; }, 600);
        })
        .catch(fail);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
